module.exports = __webpack_public_path__ + "static/media/german_assault_gun_120.b970dbeb.png";